export default {
  id: 'navigation',
  title: 'Navigation',
  content: `## Navigation

TradeReflex AI uses a compact primary navigation with core trading routes plus profile and drawer-based access to deeper tools.

---

## Primary Navigation

| Tab | Icon | What's inside |
|---|---|---|
| Home | House | Dashboard, portfolio summary, quick actions |
| Trade | Circle button | Search stocks, place orders, open charts |
| Orders | List | Pending orders, open positions, order history |
| Profile | Person | Reports, risk profile, learning, docs, settings |

---

## The Trade Button

The centre button (Trade) opens the trading screen directly. From here you can:

- Search for any NSE stock
- View the price chart
- Place a Market or Limit order
- Set Stop Loss and Target at order time

---

## Drawer And Profile Areas

The app also exposes additional routes from the side drawer and profile sections. Common destinations include:

- Profile Details
- Risk Profile
- Preparation
- Trade Performance
- Trade Analysis
- Discipline Report
- Learning Module
- ACT Practice
- Algo Flows
- Backtesting
- Markets
- AI Coach
- Trade Reports
- Documentation
- Report Issue

---

## Navigation Tips

- Tap the **back arrow** (top left) anywhere to go one level up
- The **active tab** is highlighted in the accent colour
- Deep links work — bookmarking a URL like /docs?section=act opens that exact page`,
};
